import React from 'react';
import { IconWarning } from '@sm/wds-icons';

const iconSizeStyles = {
  fontSize: '60px',
  lineHeight: '50px',
};
/* Icons adopt the size of the text they are with, there are some pre-canned sizes but they're all to small for this usage */
const TopBarFullWarningIcon: React.FC = () => {
  return (
    <span style={iconSizeStyles}>
      <IconWarning color="light" />
    </span>
  );
};

export default TopBarFullWarningIcon;
